export default "__VITE_ASSET__DhCxhf91__"